import React from 'react';
import {
  StyledContainer,
  StyledChkImg,
  StyledContentContainer,
  StyledTextContainer,
  StyledRow,
  StyledBuffer,
  StyledTitleStrong,
  StyledRowText,
  StyledAdditionalText,
  StyledSubText,
  StyledChecklistName,
} from './StepByStep.styles';
import { get, last } from 'global/lib/lodash';
import { useScreen } from 'global/styles';
import sStyles from 'global/styles';
import { useSelector } from 'react-redux';
import { sortByOrderKey } from 'global/utils';
import useBodyOverflow from 'global/hooks/useBodyOverflow';
import { ImageList } from 'global/components/image';
import Ecs from 'global/components/ecs/ecs.component.jsx';
import Image from 'global/components/image';
import { getIcon } from '../../definitions';
import { Icon } from '@mui/material';
import { Media } from 'global/components/Media';

const StepByStep = (props) => {
  // const isMobile = isMobileScreenXS();
  const { data, printView } = props;
  const Styles = sStyles();
  // const placeimage = 'https://via.placeholder.com/350x550';
  const items = get(data, 'items', []).sort(sortByOrderKey);
  const view = useSelector((state) => get(state, 'view'));

  const { isUp } = useScreen();

  const showLogo = get(props, 'showLogo', false);

  useBodyOverflow({ hidden: isUp });

  const additionalText = get(props, 'additionalText');
  const subText = get(props, 'subText');

  const longTitle = items.filter((cp) => cp.name.length > 2).length > 0;

  const is3d = get(data, '3DAssets');

  const renderTitle = (cp) => {
    return (
      <StyledTitleStrong longTitle={longTitle}>
        {cp.name}
        {!longTitle && `.`}
      </StyledTitleStrong>
    );
  };

  const getLocalHtmlLink = () => {
    const { dir } = is3d;
    const loc = last(dir.split('/'));
    const url = `/ecs/${loc}/${loc}.html`;
    return url;
  };

  const ecsData = () => {
    return { steps: items.map((item, i) => ({ stepno: i + 1, steptext: get(item, 'description', get(item, 'name', i + 1)) })) };
  };

  return (
    <StyledContainer className={props.className}>
      <div className={!showLogo && Styles.printOnly}>
        <div className={Styles.printLogoContainer}>
          <Image style={{ height: 100 }} src={get(view, 'style.props.logo')} alt={'Builder Logo'} unsetWidth />
        </div>
        {additionalText && <StyledAdditionalText>{additionalText}</StyledAdditionalText>}
        <StyledChecklistName>{get(data, 'name')}</StyledChecklistName>
        {subText && <StyledSubText>{subText}</StyledSubText>}
      </div>

      {is3d && !printView && <Ecs url={getLocalHtmlLink()} data={ecsData()} />}

      {printView ? (
        <div>
          {items.map((cp, i) => {
            const desc = get(cp, 'description', '');
            const image = get(cp, 'images.0');
            const icon = <Icon>{getIcon('step_by_step')}</Icon>;
            const images = cp.images.map((c) => ({ ...c, icon, description: desc }));

            return (
              <StyledBuffer>
                <p>{renderTitle(cp)}</p>
                {image && (
                  <StyledChkImg>
                    <Media sourceType={['fullUrl']} {...image} description={desc} icon={icon} />
                  </StyledChkImg>
                )}

                <StyledContentContainer noImage={!image}>
                  <StyledRow key={cp.id} centerVertically>
                    <StyledRowText>
                      <span dangerouslySetInnerHTML={{ __html: desc }} />
                    </StyledRowText>
                  </StyledRow>
                  {cp.images && (
                    <StyledRow>
                      <ImageList spaceBetween={3} images={images} />
                    </StyledRow>
                  )}
                </StyledContentContainer>
              </StyledBuffer>
            );
          })}
        </div>
      ) : (
        <StyledTextContainer>
          {items.map((cp, i) => {
            const desc = get(cp, 'description', '');
            const image = get(cp, 'images.0');
            const icon = <Icon>{getIcon('step_by_step')}</Icon>;
            const images = cp.images.map((c) => ({ ...c, icon, description: desc }));

            return (
              <StyledBuffer>
                <p>{renderTitle(cp)}</p>
                {image && (
                  <StyledChkImg>
                    <Media sourceType={['fullUrl']} {...image} description={desc} icon={icon} />
                  </StyledChkImg>
                )}

                <StyledContentContainer noImage={!image}>
                  <StyledRow key={cp.id} centerVertically>
                    <StyledRowText>
                      <span dangerouslySetInnerHTML={{ __html: desc }} />
                    </StyledRowText>
                  </StyledRow>
                  {cp.images && (
                    <StyledRow>
                      <ImageList spaceBetween={3} images={images} />
                    </StyledRow>
                  )}
                </StyledContentContainer>
              </StyledBuffer>
            );
          })}
        </StyledTextContainer>
      )}
    </StyledContainer>
  );
};

export default StepByStep;
